import React, { useState } from "react";
import { handleEmailSubscribe } from "../../auth/Auth";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const Subscriber = () => {
  const { authToken } = useSelector((state) => state.user);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoadingForm, setIsLoadingForm] = useState(false);

  const handleChange = (e) => {
    const { value } = e.target;
    setEmail(value);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(value)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!emailError && email !== "") {
      setIsLoadingForm(true);
      try {
        e.preventDefault();
        toast.dismiss();

        const res = await handleEmailSubscribe(authToken, { email: email });

        setEmail("");
        toast.success(
          typeof res.message === "string"
            ? res.message
            : res.message.original.message || "Subscribed Successfully "
        );
        setIsLoadingForm(false);
      } catch (error) {
        toast.error(error.message);
        console.error(error);
        setIsLoadingForm(false);
      }
    }
  };

  return (
    <>
      {/* === NEWSLETTER SECTION === */}
<section className="relative py-24 overflow-hidden">
  {/* Gradient background with smooth transition */}
  <div className="absolute inset-0 bg-gradient-to-br from-gray-600 via-gray-700 to-black">
    <div className="absolute inset-0 bg-gradient-to-b from-gray-600/30 via-gray-800/70 to-gray-900"></div>
  </div>
  
  {/* Floating Question Marks Animation */}
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {/* Question Mark 1 */}
    <div className="absolute top-20 left-10 text-white/20 text-6xl font-bold animate-bounce" style={{animationDuration: '3s', animationDelay: '0s'}}>
      ?
    </div>
    {/* Question Mark 2 */}
    <div className="absolute top-40 right-20 text-white/15 text-4xl font-bold animate-bounce" style={{animationDuration: '4s', animationDelay: '1s'}}>
      ?
    </div>
    {/* Question Mark 3 */}
    <div className="absolute bottom-32 left-1/4 text-white/10 text-8xl font-bold animate-bounce" style={{animationDuration: '5s', animationDelay: '2s'}}>
      ?
    </div>
    {/* Question Mark 4 */}
    <div className="absolute top-60 right-1/3 text-white/25 text-3xl font-bold animate-bounce" style={{animationDuration: '3.5s', animationDelay: '0.5s'}}>
      ?
    </div>
    {/* Question Mark 5 */}
    <div className="absolute bottom-20 right-10 text-white/20 text-5xl font-bold animate-bounce" style={{animationDuration: '4.5s', animationDelay: '1.5s'}}>
      ?
    </div>
    {/* Question Mark 6 */}
    <div className="absolute top-32 left-1/3 text-white/15 text-7xl font-bold animate-bounce" style={{animationDuration: '6s', animationDelay: '3s'}}>
      ?
    </div>
  </div>

  <div className="relative max-w-4xl mx-auto px-4 text-center">
    <div className="bg-white/15 backdrop-blur-xl rounded-3xl p-12 border border-white/30 shadow-2xl relative overflow-hidden">
      {/* Enhanced Card Decorations */}
      <div className="absolute top-8 right-8 w-6 h-6 bg-red-600 rounded-full animate-pulse"></div>
      <div className="absolute top-16 right-16 w-3 h-3 bg-red-400/50 rounded-full animate-pulse delay-300"></div>
      <div className="absolute bottom-8 left-8 w-4 h-4 bg-red-300/40 rounded-full animate-pulse delay-700"></div>
      <div className="absolute top-0 left-0 w-full h-3 bg-gradient-to-r from-red-500/30 to-red-600/20"></div>

      {/* Floating circles around the card */}
      <div className="absolute -top-4 -left-4 w-8 h-8 bg-gradient-to-r from-red-400/30 to-red-500/30 rounded-full animate-ping"></div>
      <div className="absolute -bottom-6 -right-6 w-12 h-12 bg-gradient-to-r from-red-400/20 to-red-500/20 rounded-full animate-pulse" style={{animationDuration: '2s'}}></div>
      <div className="absolute top-1/2 -left-6 w-6 h-6 bg-gradient-to-r from-red-300/40 to-red-400/40 rounded-full animate-bounce" style={{animationDuration: '3s'}}></div>

      <div className="relative z-10">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight">
          Stay Updated with <span className="text-red-600 relative">
            Delicious News
            <div className="absolute -top-2 -right-4 w-3 h-3 bg-red-600/60 rounded-full animate-ping"></div>
          </span>
        </h2>
        <p className="text-gray-300 text-xl mb-10 max-w-2xl mx-auto font-light leading-relaxed">
          Subscribe for exclusive offers, new menu announcements, and inspiring stories from our talented shefs.
        </p>
        <form onSubmit={onSubmit} className="max-w-lg mx-auto">
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={handleChange}
              className="flex-1 px-6 py-4 rounded-xl text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-red-600 transition-all duration-300 font-medium border-2 border-transparent focus:border-red-600 hover:shadow-lg"
              required
            />
            <button
              type="submit"
              disabled={emailError || isLoadingForm}
              className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 shadow-xl hover:shadow-red-500/30 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 relative overflow-hidden group"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-red-500/20 to-red-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <span className="relative z-10">
                {isLoadingForm ? (
                  <div className="flex items-center">
                    <svg
                      className="w-5 h-5 mr-2 animate-spin text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 100 8v4a8 8 0 01-8-8z"
                      ></path>
                    </svg>
                    Loading...
                  </div>
                ) : (
                  "Subscribe"
                )}
              </span>
            </button>
          </div>
          {/* Error warning */}
          {emailError && (
            <div className="bg-red-500/20 border border-red-500/30 mt-4 text-red-300 py-2 px-4 rounded-lg text-sm font-medium animate-fadeIn">
              {emailError}
            </div>
          )}
        </form>
        <p className="text-gray-400 text-sm mt-6 font-light">
          No spam, unsubscribe at any time. We respect your privacy.
        </p>
      </div>
    </div>
  </div>

  <style>{`
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-10px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .animate-fadeIn {
      animation: fadeIn 0.3s ease-out;
    }
  `}</style>
</section>
    </>
  );
};

export default Subscriber;